import React from 'react';
import { Flex, Box } from 'rebass';
import { HeaderSubnavLink } from 'components/Header/HeaderSubnavLink';
import { SmallLink } from 'components/Header/SmallLink';
import H1 from 'components/H1';
import { Link } from 'react-router-dom';
import cache from 'utils/cache';
import helpers from 'utils/helpers';
import { FiLayers, FiFileText, FiCalendar, FiSettings, FiPieChart } from 'react-icons/fi';

function StudyPageSubNav(props) {
    const study_title_key = `study_id_${props.study_id}`;

    // get title from cache
    let study_title = cache.get(study_title_key);

    // if we do have the value from the parent, render this
    if (props.study && props.study.title) {
        // eslint-disable-next-line
        study_title = props.study.title;
        cache.set(study_title_key, study_title);
    }

    return (
        <Flex sx={{ flexDirection: 'row', lineHeight: '24px' }}>
            <HeaderSubnavLink exact to={`/studies/${props.study_id}`} className='basic-subnav'>
                <FiLayers /> Overview
            </HeaderSubnavLink>
            {(props.study && props.study.screener && props.study.screener[0] &&  props.study.screener[0].length) ?
                <HeaderSubnavLink to={`/studies/${props.study_id}/recruit`} className='basic-subnav'>
                    <FiFileText/> (Old) Screener
                </HeaderSubnavLink>
                : ''
            } 
            <HeaderSubnavLink to={`/studies/${props.study_id}/screeners`} className='basic-subnav'>
                <FiFileText /> Screeners
            </HeaderSubnavLink>
            <HeaderSubnavLink to={`/studies/${props.study_id}/scheduling`} className='basic-subnav'>
                <FiCalendar /> Scheduling
            </HeaderSubnavLink>
            <HeaderSubnavLink to={`/studies/${props.study_id}/quotas`} className='basic-subnav'>
                <FiPieChart/> Quotas
            </HeaderSubnavLink>
            {/*<HeaderSubnavLink to={`/studies/${props.study_id}/emails`}>Activity</HeaderSubnavLink>*/}
            <HeaderSubnavLink to={`/studies/${props.study_id}/settings`} className='basic-subnav'>
                <FiSettings/> Study Settings
            </HeaderSubnavLink>
        </Flex>
    );
}

export default StudyPageSubNav;
